module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header_modal":"Payment Susccessful","description_modal":"Your payment is successful. The system has sent your purchase detail via {email}. Please check the detail for confirmation."},"th":{"header_modal":"การชำระเงินสำเร็จ","description_modal":"การชำระเงินสำเร็จระบบได้ทำการส่งรายละเอียดคำสั่งซื้อไปยังอีเมล {email} โปรดตรวจสอบรายละเอียดอีกครั้ง"}}')
  delete Component.options._Ctor
}
